// import React from 'react';
import { toast as info} from 'react-toastify';
// import PropTypes from 'prop-types';
import 'react-toastify/dist/ReactToastify.css';

// const Message = ({ message, status }) => (
//   <div className="toast-inner success">
//     <span className="toast-inner-icon"></span>
//     <div className="toast-inner-body">
//       <h5>{status}</h5>
//       <p>{message}</p>
//     </div>
//   </div>
// );

const Toast = {
  success: (message) => {
    info.success(message, {
      position: info.POSITION.TOP_RIGHT,
      hideProgressBar: true,
      autoClose: 5000
    });
  },
  error: (message) => {
    info.error(message, {
      position: info.POSITION.TOP_RIGHT,
      hideProgressBar: true,
      autoClose: 5000
    });
  },
  warning: (message) => {
    info.warning(message, {
      position: info.POSITION.TOP_RIGHT,
      hideProgressBar: true,
      autoClose: 5000
    });
  },
  info: (message) => {
    info.info(message, {
      position: info.POSITION.TOP_RIGHT,
      hideProgressBar: true,
      autoClose: 5000
    });
  }
};

// Message.propTypes = {
//   status: PropTypes.string,
//   message: PropTypes.string
// };

export default Toast;